import { PdfLayout } from "@/models/graphql-global-types";

const orderOfLayout = (layout: PdfLayout) => {
  switch (layout) {
    case PdfLayout.STANDARD:
      return 0;
    case PdfLayout.DECKMATE:
      return 1;
    case PdfLayout.DEMO:
      return 2;
  }
};

export const sortLayouts = (layouts: PdfLayout[]): PdfLayout[] => {
  return layouts.sort((a, b) => orderOfLayout(a) - orderOfLayout(b));
};
